import { ActionTypes } from "../../action-type";

const initialState = {
    topic:null,
    left_team_vote:0,
    right_team_vote:0,
};

export const votingReducer = (state=initialState,action)=>{
    switch(action.type){
        case ActionTypes.VOTING:
            return{
                ...state,
            topic:action.payload ?action.payload.topic:null,
            left_team_vote:action.payload ? action.payload.left_team_vote:0,
            right_team_vote:action.payload? action.payload.right_team_vote:0,
            }
       
        default:
            return state;
    }
}